export const nominationsFilteredVendorIdsComparator = vendorIds => nomination =>
  vendorIds.includes(nomination.vendorId);

export const nominationFilteredHasArrivedComparator =
  hasArrived => nomination =>
    nomination.hasArrived === hasArrived[0];
